import { useMemo, useState } from 'react';
import MaintVendors from './MaintVendors';
import MaintAmcContracts from './MaintAmcContracts';
import MaintSpareParts from './MaintSpareParts';
import MaintAssets from './MaintAssets';
import MaintSlaConfig from './MaintSlaConfig';

function MaintMastersHub({ token, selectedProperty }) {
  const tabs = useMemo(() => ([
    { key: 'vendors', label: 'Vendors', render: () => <MaintVendors token={token} selectedProperty={selectedProperty} /> },
    { key: 'amc-contracts', label: 'AMC Contracts', render: () => <MaintAmcContracts token={token} selectedProperty={selectedProperty} /> },
    { key: 'spare-parts', label: 'Spare Parts', render: () => <MaintSpareParts token={token} selectedProperty={selectedProperty} /> },
    { key: 'assets', label: 'Assets', render: () => <MaintAssets token={token} selectedProperty={selectedProperty} /> },
    { key: 'sla-config', label: 'SLA Configuration', render: () => <MaintSlaConfig token={token} selectedProperty={selectedProperty} /> }
  ]), [token, selectedProperty]);

  const [activeTab, setActiveTab] = useState('vendors');
  const currentTab = tabs.find((t) => t.key === activeTab) || tabs[0];

  return (
    <div className="page-shell">
      <h2 style={{ color: '#1f8f4d', marginBottom: '0.75rem' }}>Engineering - Masters</h2>
      <div style={{ display: 'flex', gap: '0.45rem', flexWrap: 'wrap', borderBottom: '1px solid #dcdde1', paddingBottom: '0.55rem', marginBottom: '0.8rem' }}>
        {tabs.map((tab) => (
          <button
            key={tab.key}
            onClick={() => setActiveTab(tab.key)}
            style={{
              padding: '0.42rem 0.8rem',
              borderRadius: '6px',
              border: '1px solid #dcdde1',
              cursor: 'pointer',
              background: tab.key === currentTab.key ? 'var(--theme-accent)' : '#fff',
              color: tab.key === currentTab.key ? '#fff' : '#1f8f4d',
              fontWeight: 700
            }}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <div>{currentTab.render()}</div>
    </div>
  );
}

export default MaintMastersHub;
